import { Button } from "@/components/ui/button";
import { FloppyDisk, PencilSimple, Prohibit, ShoppingCartSimple, X } from "@phosphor-icons/react";

export function DrawerFooterActions({
  readOnly,
  isCreate,
  editMode,
  canEdit,
  addingToCart,
  saving,
  onAddToCart,
  onEdit,
  onCancel,
  onSave,
  allowAddToCart = false,
  canBlock = false,
  isBlocked = false,
  blocking = false,
  onToggleBlock,
}) {
  return (
    <div className="sticky bottom-0 mt-8 flex justify-end gap-2 border-t border-zinc-200 bg-white pt-4">
      {canBlock && !editMode && (
        <Button
          variant="outline"
          className={`mr-auto rounded-sm ${
            isBlocked ? "border-zinc-300 text-zinc-700" : "border-red-300 text-red-600 hover:bg-red-50"
          }`}
          onClick={onToggleBlock}
          disabled={blocking}
          data-testid="product-block-toggle-button"
        >
          <Prohibit size={16} className="mr-1.5" />
          {blocking ? "Working..." : isBlocked ? "Unblock" : "Block"}
        </Button>
      )}
      {(!readOnly || allowAddToCart) && !isCreate && !editMode && (
        <>
          <Button
            variant="outline"
            className="rounded-sm border-zinc-300"
            onClick={onAddToCart}
            disabled={addingToCart}
            data-testid="product-add-to-cart-button"
          >
            <ShoppingCartSimple size={16} className="mr-1.5" />
            {addingToCart ? "Adding..." : "Add to Cart"}
          </Button>
          {canEdit && (
            <Button
              className="rounded-sm bg-blue-600 text-white hover:bg-blue-700"
              onClick={onEdit}
              data-testid="product-edit-button"
            >
              <PencilSimple size={16} className="mr-1.5" /> Edit
            </Button>
          )}
        </>
      )}
      {editMode && (
        <>
          <Button
            variant="outline"
            className="rounded-sm border-zinc-300"
            onClick={onCancel}
            data-testid="product-cancel-button"
          >
            <X size={16} className="mr-1.5" /> Cancel
          </Button>
          <Button
            className="rounded-sm bg-blue-600 text-white hover:bg-blue-700"
            onClick={onSave}
            disabled={saving}
            data-testid="product-save-button"
          >
            <FloppyDisk size={16} className="mr-1.5" /> {saving ? "Saving..." : "Save"}
          </Button>
        </>
      )}
    </div>
  );
}
